export const RADIO_STATION_SET = 'RADIO_STATION_SET';
export const RADIO_VOLUME_SET = 'RADIO_VOLUME_SET';
export const RADIO_PLAYING_SET = 'RADIO_PLAYING_SET';
export const RADIO_NOW_PLAYING_SET = 'RADIO_NOW_PLAYING_SET';

export const HISTORY_SET = 'HISTORY_SET';
export const HISTORY_ADD = 'HISTORY_ADD';
export const HISTORY_REMOVE = 'HISTORY_REMOVE';
